import { useQuery } from '@tanstack/react-query';
import type AgentApiProvidedJobPostsShow from '@/types/serializers/AgentApiProvidedJobPostsShow';

export default function useFetchProvidedJobPost(id: number) {
  return useQuery({
    queryKey: ['providedJobPost', id],
    queryFn: async () => {
      const response = await fetch(`/agent/api/provided_job_posts/${id}.json`, {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token':
            document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
      });

      if (!response.ok) {
        throw new Error('求人情報の取得に失敗しました');
      }

      const data: AgentApiProvidedJobPostsShow = await response.json();
      return data;
    },
    retry: (failureCount, error) => {
      // 401, 403, 404 エラーの場合はリトライしない
      if (
        error instanceof Error &&
        (error.message.includes('認証') ||
          error.message.includes('権限') ||
          error.message.includes('見つかりません'))
      ) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
